import { render, staticRenderFns } from "./TransplantSurgeryDetailsView.vue?vue&type=template&id=58a4bcff"
import script from "./TransplantSurgeryDetailsView.vue?vue&type=script&lang=js"
export * from "./TransplantSurgeryDetailsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports